import { render, staticRenderFns } from "./SwiperView.vue?vue&type=template&id=47f6c15b&scoped=true&"
import script from "./SwiperView.vue?vue&type=script&lang=js&"
export * from "./SwiperView.vue?vue&type=script&lang=js&"
import style0 from "./SwiperView.vue?vue&type=style&index=0&id=47f6c15b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6c15b",
  null
  
)

export default component.exports